@if (isLoading() || isLoggingOut() || (isAuthenticated() && !session.loaded())) {
  <onrsr-loader [fullScreen]="true" [size]="'large'" />
} @else if (!isAuthenticated()) {
  <router-outlet />
} @else {
  <!-- Keyed on the session version so the shell (and its menu) is rebuilt when permissions change. -->
  @for (version of [session.version()]; track version) {
    <app-shell />
  }
}

@if (reauth.required()) {
  <app-session-expired />
}
